import { Component, OnInit } from '@angular/core';

import { DialogTranslations } from '../../config';
import { DialogResult } from '../../models/dialog.result';
import { DialogBehaviorService } from '../../services/dialog-behavior.service';
import { DialogDataService } from '../../services/dialog-data.service';

@Component({
  selector: 'mw-dialog-cancel-button',
  template: `<button
    mat-stroked-button
    color="primary"
    [disabled]="disabled"
    (click)="onClick()"
    *ngIf="translations.noButton"
  >
    {{ translations.noButton | translate }}
  </button>`,
})
export class CancelButtonComponent implements OnInit {
  disabled = false;
  translations: DialogTranslations;
  constructor(
    private readonly dataService: DialogDataService,
    private behaviorService: DialogBehaviorService
  ) {}

  ngOnInit(): void {
    this.translations = this.dataService.translations;
    this.dataService
      .getDisabledState('cancelButton')
      .subscribe((disabled) => (this.disabled = disabled));
  }

  onClick(): void {
    this.dataService
      .getPreActions('cancelButton')
      .forEach((action) => action());
    this.behaviorService.closeDialog.next(DialogResult.Cancel);
  }
}
